import React from 'react';
import Ionicon from "react-ionicons";

export const ErrorModal = props => {
         const { isOpen, onClose, header, message } = props;

        if (isOpen === false)
            return null;

        const mainError = {
            h2: "Have you saved your work?",
            p: "You still have a form open on this page. Please save or cancel to proceed.",
        };

        return (
            <div className="popup-default">
                <div className="popup-inner">
                    <div className="popup-content">
                        <button className="close-popup" type="button" onClick={ () => onClose() }><Ionicon icon="ion-close"/></button>
                        <h2 className="h2">{ header || mainError.h2}</h2>
                        <p className="p-tag">{ message || mainError.p }</p>
                    </div>
                </div>
            </div>
        )
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/ErrorModal.js